import { render, staticRenderFns } from "./MedicationTypePillRenderer.vue?vue&type=template&id=ab363d8c&scoped=true"
import script from "./MedicationTypePillRenderer.vue?vue&type=script&lang=js"
export * from "./MedicationTypePillRenderer.vue?vue&type=script&lang=js"
import style0 from "./MedicationTypePillRenderer.vue?vue&type=style&index=0&id=ab363d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab363d8c",
  null
  
)

export default component.exports